/**
 * Created by jpilz on 2/13/17.
 */
//import $ from'jquery';
//import ko from 'knockout';
import _ from 'lodash';
//import axios from 'axios';
import async from 'async';

import preferencesUtil from './preferencesUtil';
import ssoObj from './ssoObj';
import ssoUtil from './ssoUtil';
import reviewUtil from './reviewUtil';
import jdmApiUtil from './jdmApiUtil';
import optionsUtil from './optionsUtil';
import jobUtil from './jobUtil';
import customUtil from './customUtil';
import profileUtil from './profileUtil';
import jobObj from './jobObj';
import userObj from './userObj';
import utils from './utils';

//import base64 from 'base64-js';
//import mcrypt from 'js-rijndael';
//import CryptoJS from 'crypto-js';

//import '../bindings/aes';

export default class bootUtil {

    constructor(context) {
        this.name = "bootUtil";
        this.context = context;

        this.ssoObj = new ssoObj();

        this.context.loginStatusObj.subscribe( response => {
            //this.processloginStatusObj(response);

        });

    }

    appID() {
        return this.context.ApplicationId;
    }


    processloginStatusObj(loginStatusObj) {

        //let self = this;

        async.series([ 
            // Process params passed into the Application
            (callback) => {

                this.context.loginStatusObj().staticParams = "processing..";
                this.processStaticParams();


                if((this.context.subparentid() == null) || (this.context.subparentid() == undefined) || (this.context.subparentid() == 'null') || (this.context.subparentid() == ''))
                {
                    this.context.subparentid(this.context.subid());
                    console.log("bootUtil:processloginStatusObj: No Parent: hasParent: %o", this.context.hasParent());
                } else
                {
                    this.context.hasParent(true);
                    console.log("bootUtil:processloginStatusObj: hasParent: %o", this.context.hasParent());
                }

                this.context.loginStatusObj().staticParams = "Complete";
                console.log("bootUtil:processloginStatusObj: context: %o", this.context);
                callback(null,"Complete");
            },

            //Process URL Params
            (callback) => {
                console.log("bootUtil:processloginStatusObj: Process #2  loginStatusObj: %o,", this.context.loginStatusObj());
                this.context.loginStatusObj().urlParams = "processing...";
                this.processUrlParams();
                console.log("bootUtil:processloginStatusObj: Check and Process any URL Params %o,", this.context.loginStatusObj());
                callback(null,"Complete");

            },

             // Get Memberbase Profile
            (callback) => {

                //Load editorStyleSheet
                this.context.eventManager.notifySubscribers(null,"styleSheetChanged");
               
                this.context.loginStatusObj().Profile = "GettingProfile";
                console.log("bootUtil:processloginStatusObj: Process #3  loginStatusObj: %o,", this.context.loginStatusObj());

                console.log("bootUtil:processloginStatusObj: Profile == \"GetProfile\": %o", loginStatusObj);
                let profileUtilObj = new profileUtil(this.context);

                profileUtilObj.getToken().then( response => {
                    console.log("bootUtil:processloginStatusObj: Profile == \"GetProfile:Token\" response: %o", response);
                    if(response == "Authorized")
                    {
                        profileUtilObj.getProfile().then( response => {
                            console.log("bootUtil:processloginStatusObj: Profile == \"GetProfile\" response: %o", response);
                            callback(null,"Complete");
                        });
                    }
                    else
                    {
                        this.context.eventManager.notifySubscribers({modalTitle:"Missing or InValid Profile Token", modalBody:"The application was unable to load a token for the profile"},"messageModel");
                        callback(null,"In Complete");
                    }
                });
            },

            //If JDMAPI Token Supplied Check it. 
            (callback) => {

                console.log("bootUtil:processloginStatusObj: checking for null this.context.apiAccessToken value:", this.context.apiAccessToken );

                if( typeof this.context.apiAccessToken === 'undefined' || this.context.apiAccessToken === null )
                {
                    console.log("bootUtil:processloginStatusObj: setting apiAccessToken to empty");
                    this.context.apiAccessToken = "";
                }

                console.log("bootUtil:processloginStatusObj: Process #4  paramObj: %o, length:", this.context.paramObj(), this.context.apiAccessToken.toString().length);

                let jdmApiUtilObj = new jdmApiUtil(this.context);

                if(this.context.apiAccessToken.toString().length > 40)
                {

                    jdmApiUtilObj.tryAPIAutoLogin().then( response => {
                        console.log("bootUtil:jdmApiLogin: connection test response: %o", response);

                        if(response === true)
                        {
                            callback(null,"apiLoginToken Supplied Valid");
                            this.context.loginStatusObj().ApplicationData == "Load"
                        }
                        else
                        {
                            this.context.apiAccessToken = "";
                            this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Invalid API token supplied."},"messageModel");
                            callback(null,"apiLoginToken Supplied InValid");

                        }
                        
                    }).catch( err => {
                        this.context.apiAccessToken = "";
                        this.context.apiUserID = 0;
                        console.log("bootUtil:processloginStatusObj: Error caught: %o", err );
                        this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Invalid API token supplied.."},"messageModel");
                        callback(true);
                    });
                }
                else
                {
                    callback(null);
                }

                /*
                else
                {
                    jdmApiUtilObj.apiLogin().then( response =>{
                        console.log("bootUtil:jdmApiLogin: Else Loginresponse: %o", response);
                        this.context.loginStatusObj().ApplicationData == "Load";
                        callback(null,"apiLoginToken Supplied Valid");
                    }).catch( response => {
                        console.log("bootUtil:processloginStatusObj: Error on Else Login caught: %o", err );
                        callback(true);
                    });
                }
                */

            },

            //If no Token Login but display error
            (callback) => {

                console.log("bootUtil:processloginStatusObj: Process #5  check apiAccessToken lenght");
                console.log("bootUtil:processloginStatusObj: Process #5  paramObj: %o, length:", this.context.paramObj(), this.context.apiAccessToken.toString().length);

                let jdmApiUtilObj = new jdmApiUtil(this.context);

                if(this.context.apiAccessToken.toString().length < 40)
                {
                    if(this.context.loginStatusObj().Mode == "Standard")
                    {
                        //this.context.eventManager.notifySubscribers({modalTitle:"Missing or InValid JDM API Credentials", modalBody:"You can continue to use the application.<br><br><small>This error has been logged<small>"},"messageModel");
                        this.context.Raven.captureMessage('InValid JDM API Credentials', {level:'info'});
                    }

                    jdmApiUtilObj.apiLogin().then( response => {
                        if(response)
                        {
                            //this.context.loginStatusObj().JDMAPI = true;
                            console.log("bootUtil:jdmApiLogin: API logged in response: %o", response);
                            this.context.loginStatusObj().JDMAPI = "Complete";
                            callback(null,"Complete: apiLogin - Forced to get jdmPAI token");
                        }
                        else
                        {
                            //this.context.loginStatusObj().JDMAPI = false;
                            console.warn("bootUtil:jdmApiLogin: API logged in FAILED");
                            this.context.loginStatusObj().JDMAPI = "Error";
                            callback(null,"Error - apiLogin");
                        }
                        
                    }).catch( response => {
                        
                        console.warn("bootUtil:jdmApiLogin: Process #5  API logged in FAILED");

                    });
                } else {
                    console.log("bootUtil:processloginStatusObj: Process #5  No valid API Access Token", this.context.paramObj());
                    callback(null);
                }

            },
            
            // Check For if User should login
            (callback) => {
                console.log("bootUtil:processloginStatusObj: Process #6  loginStatusObj: %o,", this.context.loginStatusObj());

                console.log("bootUtil:processloginStatusObj:loginStatusObj.API : %o subid: %s", this.context.loginStatusObj(), this.context.subid() );
                this.context.loginStatusObj().ApplicationData = "Load";
                callback(null, "Called");

                /*
                let self = this;
                if((this.context.loginStatusObj().API == "GetUserInfo") && (this.context.subid() == ""))
                {
                    console.log("bootUtil:processloginStatusObj:loginStatusObj.API : %o subid: %s", this.context.loginStatusObj(), this.context.subid() );
        
                    let ssoUtilObj = new ssoUtil(this.context);
        
                    ssoUtilObj.isAuthenticated().then( response => { 
        
                        console.log("bootUtil:processloginStatusObj: Process #6 response: %o", response);
                        
                        if(response == "false")
                        {
                            this.context.eventManager.notifySubscribers("Login","show-boot-modal");
                            //ssoUtilObj.login({username:"blrnpd",password:"smileX"});
                            this.context.loginStatusObj().ApplicationData == "Load";
                            self.callback(null,response);
                        }
                        self.callback(null,"Complete: User Login Check");
                        this.context.loginStatusObj().ApplicationData == "Load";
                        
                    }).catch( response => {
                        console.log("bootUtil:processloginStatusObj: %o", response);
                        self.callback(null,response);
                    });
        
                }
                else if (this.context.loginStatusObj().API != "Skipped")
                {
                    //Get additional user information:
                    console.log("bootUtil:processloginStatusObj:loginStatusObj.API : %o subid: %s", this.context.loginStatusObj(), this.context.subid() );
                    //this.context.loginStatusObj().API = "Skipped";
                    //this.context.loginStatusObj().JDMAPI = "GetToken";
                    //this.context.loginStatusObj().Profile = "GetProfile";
                    this.context.loginStatusObj().ApplicationData = "Load";
                    callback(null, "Called");
                }
                */
                
            },
            
            
            //Review Check and Load
            (callback) => {
                console.log("bootUtil:processloginStatusObj: Position #6  loginStatusObj: %o,", this.context.loginStatusObj());
                if((this.context.loginStatusObj().ApplicationData == "Load") && (this.context.loginStatusObj().Mode == "Review") )
                {
                    console.log("bootUtil:loadApplicationData:$s %o", this.context.loginStatusObj().Mode);
                    this.loadReviewModel();
                    this.context.loginStatusObj().ApplicationData = 'Complete';
                }
                else
                {
                    this.context.loginStatusObj().ApplicationData = 'Complete';
                    callback(null,"Skipped Review Mode");
                }
            },

            //Load Application
            (callback)=> {

                console.log("bootUtil:processloginStatusObj: Position #8  loginStatusObj: %o,", this.context.loginStatusObj());

                if((this.context.loginStatusObj().ApplicationData == 'Complete') && (this.context.loginStatusObj().Mode != "Review") )
                {
                    console.log("bootUtil:loadApplicationData:Complete: %o", this.context.loginStatusObj());

                    let customUtilObj = new customUtil(this.context);
                    
                    //Load Job Header
                    customUtilObj.getCustomHeaderTitles().then( result => {
                        customUtilObj.getAllCustomHeaderData();
                    }).catch( response => {
                        console.log("bootUtil:processloginStatusObj: Error:", response);
                    });

                    //Load Jobs and Information
                    let jobUtilObj = new jobUtil(this.context);
                    jobUtilObj.getJobList().then(() => {
                        console.log("nav-job-list:getJobList:Finished loading Job List");
                        //$('#summaryModal').modal('show');
                    });

                    //Load Users
                    this.loadStandardApplicationData();

                    this.context.loginStatusObj().Complete = true;
                    this.context.eventManager.notifySubscribers(this.context.loginStatusObj(),"loginStatus");
                    this.context.eventManager.notifySubscribers("hide","show-boot-modal");

                    this.context.eventManager.notifySubscribers("home","navChanged");

                    callback(null,"Appload Complete");
                    
                }
                else
                {
                    callback(null, "bootUtil Skipped Complete");
                }

                
            }

        ], function(err,results) {
            console.log('bootUtil:processloginStatusObj err: %o  results: %o', err, results);
            
        });

    }

    processStaticParams() {

        console.log("bootUtil:processStaticParams: paramObj %o", this.context.paramObj());

        //Check for Test Cookie
        let testCookie = this.context.readCookie('BlrTestCookie');

        if(this.context.readCookie('BlrTestCookie') !== null)
        {
            console.log("bootUtil:processStaticParams: BlrTestCookie: ", testCookie);
            
           let testObj = JSON.parse(testCookie);

           console.log("bootUtil:processStaticParams: testObj: %o", testObj);
           console.log("bootUtil:processStaticParams: subid: %o", testObj.subid);

            this.context.loginStatusObj().Mode = testObj.mode;
            this.context.subid(testObj.subid);
            console.log("bootUtil:processStaticParams: subid: %o", this.context.subid());
            this.context.subparentid(testObj.subparentid);

            this.context.partnerid(testObj.partnerid);
            this.context.apiAccessToken = testObj.apiAccessToken;
            this.context.apiUserID = testObj.apiUserID;

            this.context.subid.valueHasMutated();
            this.context.subparentid.valueHasMutated();
            this.context.partnerid.valueHasMutated();

           console.log("bootUtil:processStaticParams: context: %o", this.context);

           return 'test Mode';

        } else
        {
            console.log("bootUtil:processStaticParams: No TestCookie Found");
        }

        // Process for new Customer Central
        if( (typeof this.context.paramObj().subid !== 'undefined') && (typeof this.context.paramObj().subid !== 'object'))
        {
            //Old Login
            console.log("bootUtil:processStaticParams: has subid");
            this.context.loginStatusObj().Mode = this.context.loginStatusObj().mode;
            this.context.subid(this.context.paramObj().subid);
            this.context.subparentid(this.context.paramObj().subparentid);

            this.context.partnerid(this.context.paramObj().partnerid);
            this.context.apiAccessToken = this.context.paramObj().apiAccessToken;
            this.context.apiUserID = this.context.paramObj().apiUserID;

            this.context.subid.valueHasMutated();
            this.context.subparentid.valueHasMutated();
            this.context.partnerid.valueHasMutated();

            console.log("bootUtil:processStaticParams: context: %o", this.context);

        }
        else if ((this.context.paramObj().subid !== null) && (typeof this.context.paramObj().subid === 'object')) {

          // New Customer Central Login
          if (this.context.paramObj().subid.legacyUserId !== null) {

            console.log('header:processParams: New Customer Central Login: context.paramObj().subid.legacyUserId:  %o', this.context.paramObj().subid.legacyUserId);

            this.context.subid(this.context.paramObj().subid.legacyUserId);

            this.context.subparentid(this.context.paramObj().subid.legacyParentUserId);

            this.context.partnerid(this.context.paramObj().partnerid);
            this.context.apiAccessToken = this.context.paramObj().subid.apiToken;
            this.context.apiUserID = this.context.paramObj().apiUserID;

            this.context.subid.valueHasMutated();
            this.context.subparentid.valueHasMutated();
            this.context.partnerid.valueHasMutated();

          } else { 

            console.log('header:processParams: New Customer Central Login: context.paramObj().subid.userId:  %o', this.context.paramObj().subid.userId);

            this.context.subid(this.context.paramObj().subid.userId);

            this.context.subparentid(this.context.paramObj().subid.parentId);

            this.context.partnerid(this.context.paramObj().partnerid);
            this.context.apiAccessToken = this.context.paramObj().subid.apiToken;
            this.context.apiUserID = this.context.paramObj().apiUserID;

            this.context.subid.valueHasMutated();
            this.context.subparentid.valueHasMutated();
            this.context.partnerid.valueHasMutated();

          }

        }
        else
        {
            console.log("no subid");
            this.context.paramObj().Mode = "StandAlone";
        }

    }


    processUrlParams() {

        var oGetVars = {};

        if (window.location.search.length > 1) {
            for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&"); nKeyId < aCouples.length; nKeyId++) {
                aItKey = aCouples[nKeyId].split("=");
                oGetVars[decodeURIComponent(aItKey[0])] = aItKey.length > 1 ? decodeURIComponent(aItKey[1]) : "";
            }
        }

        if(!_.isNil(oGetVars))
        {
            this.context.loginStatusObj().urlParams = oGetVars;
        }

        this.context.loginStatusObj().urlParams = oGetVars;
            
        this.checkApplicationMode();

        console.log(this.context.loginStatusObj());

    }

    checkApplicationMode() {

        console.log('bootUtil:checkApplicationMode:  paramObj: %o', this.context.paramObj());
        
        this.context.loginStatusObj().Mode = this.context.paramObj().mode;
        this.context.loginStatusObj.valueHasMutated();

        console.log('bootUtil:checkApplicationMode:  loginStatusObj: %o', this.context.loginStatusObj());

        /*
        if(this.context.paramObj().rid !== undefined)
        {
            console.log("bootUtil:checkApplicationMode - Review");
            this.context.loginStatusObj().Mode = "Review";
            //this.context.loginStatusObj.valueHasMutated();
        }
        else
        {
            console.log("bootUtil:checkApplicationMode - Standard");
            this.context.loginStatusObj().Mode = "Standard";
            //this.context.loginStatusObj.valueHasMutated();
        }
        */
    }

    parseSubsID(cookie) {
        let parseCookie = cookie.split(",");

        console.table(parseCookie);

        console.log(this.context.Raven.isSetup());
        console.log(this.context.Raven);


        let SubID = _.filter(
            parseCookie,
            function( s ) { return s.indexOf( 'mberbase_id' ) !== -1; }
        );

        console.log("SubID: " + SubID.toString().split(":")[1]);
        this.context.subid(SubID.toString().split(":")[1]);

        if(this.context.subid.length > 4)
        {
            //this.context.loginStatusObj().UserValid = true;
            this.context.Raven.setUserContext({
                id: this.context.subid()
            })
        }
        else {
            this.context.Raven.captureMessage('BootUtil:parseSubsID - bad cookie length');
            throw new Error("Missing or incorrect SubID");
        }

    }


    appLogin() {

        
        //If mode is Standard
        if(this.context.loginStatusObj().Mode == "Standard")
        {
            let ssoUtilObj = new ssoUtil(this.context);

            ssoUtilObj.isAuthenticated().then( response => {
                console.log("bootUtil:appLogin:isAuthenticated");
                console.log(response);
    
               if(response == 'false')
               {
                ssoUtilObj.login({username:"blrnpd",password:"smiley"}).then( lognResponse => {
                console.log("bootUtil:appLogin:login");
                console.log(lognResponse);
                //this.readCookies(); decrypt
                this.readWebAuthCookie();
                this.jdmApiLogin();
                this.loadStandardApplicationData();
                })
               }
               else
               {
                console.log("No need to Login in");
                //this.readCookies(); decrypt
                this.readWebAuthCookie();
                this.jdmApiLogin();
                this.loadStandardApplicationData();
               }

               // this.context.eventManager.notifySubscribers("hide","show-boot-modal");
    
            });
        }
        else if(this.context.loginStatusObj().Mode == "Review")
        {

            // https://dev.sites.blr.com/blr/jdm/index.html?RID=4003507b-369f-0137-2fc5-fc56c4ec3466
            
            this.jdmApiLogin().then( (response) => { 
                this.loadReviewModel();
            });
            
        }
        
    }

    jdmApiLogin() {

        let jdmApiUtilObj = new jdmApiUtil(this.context);

        console.log("bootUtil:jdmApiLogin: loginStatusObj: %o",this.context.loginStatusObj())
        console.log("bootUtil:jdmApiLogin: access_token: %o  access_id: %o",this.context.readCookie('access_token'),this.context.readCookie('access_id'));

        return new Promise((resolve, reject) => {

            if((this.context.readCookie('access_token') !== null) && (this.context.readCookie('access_id') !== null))
            {
                this.context.apiAccessToken = this.context.readCookie('access_token');
                this.context.apiUserID = this.context.readCookie('access_id');

                console.log("bootUtil:jdmApiLogin: Trying API AutoLogin - Cookies Found");
                jdmApiUtilObj.tryAPIAutoLogin().then( response => {
                    
                    if(response)
                    {
                        //this.context.loginStatusObj().JDMAPI = true;
                        console.log("bootUtil:jdmApiLogin: API logged in via Auto response: %o",response);
                        
                        this.context.loginStatusObj.JDMAPI = "Complete";
                        resolve(true);
                    }
                    else
                    {
                        //this.context.loginStatusObj().JDMAPI = false;
                        jdmApiUtilObj.apiLogin().then( response => {
                            
                        });
                        this.context.loginStatusObj.JDMAPI = "Error";
                        resolve(false);
                    }
                })
            }
            else
            {
                console.log("bootUtil:jdmApiLogin: Trying API Login - No cookies found: ");
                jdmApiUtilObj.apiLogin().then( response => {
                    if(response)
                    {
                        //this.context.loginStatusObj().JDMAPI = true;
                        console.log("bootUtil:jdmApiLogin: API logged in response: %o", response);
                        this.context.loginStatusObj.JDMAPI = "Complete";
                        resolve(true);
                    }
                    else
                    {
                        //this.context.loginStatusObj().JDMAPI = false;
                        console.warn("bootUtil:jdmApiLogin: API logged in FAILED");
                        this.context.loginStatusObj.JDMAPI = "Error";
                        resolve(false);
                    }
                    
                });
            }

        });

    }


    loadStandardApplicationData() {

        console.log("bootUtil:loadStandardApplicationData");

        let pUtil = new preferencesUtil(this.context);
        pUtil.getPreferences();

        let oUtil = new optionsUtil(this.context);

        //Load Styles
        oUtil.getInlineStyles("inline").then( (result) => {
            console.log("getInlineStyles: Return");
            //this.log(result);
            this.context.inLineStyleArray(result);
            this.context.formatInlineStyles();
            return true;
            //self.eventManager.notifySubscribers(self.loginStatusObj(),"loginStatus");
        }).then( (result) => {
            oUtil.getOptions("internal-users").then( (result) => {
                console.log("internal-users");
                console.log(result);
                this.context.userEmployeeList(result);
                console.log("bootUtil:loadStandardApplicationData:internal-users - complete");
                this.context.loginStatusObj().ApplicationData = 'Complete';
                this.context.loginStatusObj.valueHasMutated();
                return true;
            } );
        }).catch( result => {

            return false;

        });

        /*
        //Load Users 
        oUtil.getOptions("internal-users").then( (result) => {
            console.log("internal-users");
            console.log(result);
            this.context.userEmployeeList(result);
            console.log("bootUtil:loadStandardApplicationData:internal-users - complete");
            this.context.loginStatusObj().ApplicationData = 'Complete';
            this.context.loginStatusObj.valueHasMutated();
        } );
        */
    

    }

    loadReviewModel() {

        console.log("bootUtil:loadReviewModel:");

        let reviewUtilObj = new reviewUtil(this.context);
        let jobid = "";
        let subid = "";
        console.log("bootUtil:loadReviewModel:Check RID: " + this.context.paramObj().rid);

        reviewUtilObj.checkReviewForNextInProcess().then( response => {
            console.log("bootUtil:checkReviewForNextInProcess:  response: %", response);
            console.log(response);
            console.log(response.jobid);
            jobid = response.jobid;
            subid = response.subid;
            this.context.loginStatusObj().User = response.jdmUserID;
            this.context.subid(response.subid);

            let optionsUtilObj = new optionsUtil(this.context);

            optionsUtilObj.completeUserCheck().then( response => {

                this.context.user(new userObj(response));
                console.log("bootUtil:checkReviewForNextInProcess: response", response);

            }).then( response => { 

                console.log("bootUtil:checkReviewForNextInProcess: jobid: %s,   subid: %s", jobid, subid);

                let jobUtilObj = new jobUtil(this.context);

                jobUtilObj.getJob({ jobid:jobid, subid:subid } ).then( response => {

                    let newJob = new jobObj(response.data[0]);
                    console.log("bootUtil:checkReviewForNextInProcess: Job:%o,  response: %o", newJob, response )
                    newJob.getWorkflows(this.context);
                    console.log("bootUtil:loadReviewModel call: show-boot-modal/hide");
                    this.context.eventManager.notifySubscribers("hide","show-boot-modal");
                    this.context.eventManager.notifySubscribers(newJob,"reviewApproveJob");
                    console.log("bootUtil:loadReviewModel sent: reviewApproveJob ");

                });
            }).catch( errorMsg => {

                console.log("bootUtil:checkReviewForNextInProcess:  ERROR:: %s", errorMsg);

            });
        });

    }

    loadSupportingData() {



    }
    

    readCookies()
    {
        console.log("bootUtil:readCookies:");
        //console.log(this.context.readCookie("WebAuthToken"));

        /*
        let key = CryptoJS.enc.Latin1.parse('au33hr9xbehjkw3c'); 
        //let key = "97, 117, 51, 51, 104, 114, 57, 120, 98, 101, 104, 106, 107, 119, 51, 99";
        let ivItem = CryptoJS.enc.Latin1.parse('pertuxx318fb38c2'); 
        //let iv = "53, 68, 101, 97, 82, 102, 106, 52, 105, 72, 104, 66, 108, 117, 70, 102, 121, 71, 68, 98, 80, 65";

        var encryptedlogin = CryptoJS.AES.decrypt(this.context.readCookie("WebAuthToken"), key,  
                {  
                    keySize: 128 / 8,  
                    iv: ivItem,  
                    mode: CryptoJS.mode.CBC,  
                    padding: CryptoJS.pad.Pkcs7  
                });

        */

        /*
        CryptoJS.enc.Base64.parse('SGVsbG8sIFdvcmxkIQ=='); 
        var base64 = CryptoJS.enc.Base64.stringify(words); 
        var words = CryptoJS.enc.Latin1.parse('Hello, World!'); 
        var latin1 = CryptoJS.enc.Latin1.stringify(words); 
        var words = CryptoJS.enc.Hex.parse('48656c6c6f2c20576f726c6421'); 
        var hex = CryptoJS.enc.Hex.stringify(words); 
        var words = CryptoJS.enc.Utf8.parse('𤭢'); 
        var utf8 = CryptoJS.enc.Utf8.stringify(words); 
        var words = CryptoJS.enc.Utf16.parse('Hello, World!'); 
        var utf16 = CryptoJS.enc.Utf16.stringify(words); 
        var words = CryptoJS.enc.Utf16LE.parse('Hello, World!'); 
        var utf16 = CryptoJS.enc.Utf16LE.stringify(words);
        */

        /*
            Pkcs7 (the default)
            Iso97971
            AnsiX923
            Iso10126
            ZeroPadding
            NoPadding
        */

        //console.log(encryptedlogin.toString(CryptoJS.enc.Latin1));
        //this.parseSubsID(encryptedlogin.toString(CryptoJS.enc.Latin1));
        //console.log(CryptoJS.enc.Latin1.stringify(encryptedlogin));

        /* --js-rijndael
        let key = [].slice.call(base64.toByteArray("au33hr9xbehjkw3c"));
        let iv = [].slice.call(base64.toByteArray("5DeaRfj4iHhBluFfyGDbPA"));
        let message = [].slice.call(this.context.readCookie("WebAuthToken"));
        let clearText = String.fromCharCode.apply(this, mcrypt.decrypt(message, iv, key, 'rijndael-128','cbc'));
        */


    }

    readWebAuthCookie() {

        console.log("bootUtil:readWebAuthCookie");

        if(utils.tryParseJSON(this.context.readCookie("WebAuthToken")))
        {
            let tempJSON = JSON.parse(this.context.readCookie("WebAuthToken"));
            console.log(tempJSON);
            console.log(tempJSON.user.memberbase_id);
            this.context.subid(tempJSON.user.memberbase_id.toString());
            //this.context.loginStatusObj().UserValid = true;
        }
        else
        {
            throw new Error("Can't parse WebAuthToken");
        }
    }

    unpack(str) {
        let bytes = [];
        for(var i = 0, n = str.length; i < n; i++) {
            var char = str.charCodeAt(i);
            bytes.push(char >>> 8, char & 0xFF);
        }

        return bytes;
    }

}


// WEBPACK FOOTER //
// ./src/objects/bootUtil.js